import moment from 'moment';

const dataOpration = {
  /**
   * 判空
   * 避免0也判空
   */
  isEmpty(v) {
    return !v && v !== 0;
  },
  isNotEmpty(v) {
    return !dataOpration.isEmpty(v);
  },
  _getTimeObjFromRanger(ranger) {
    if (ranger && ranger.length) {
      const [startTime, endTime] = ranger;
      return {
        beginTime: +new Date(startTime),
        startTime: +new Date(startTime),
        endTime: +new Date(endTime),
      };
    }
  },
  // 按精度获取, s,m,H
  getTimeByAcc(acc = 's') {
    let f = '';
    switch (acc) {
      case 's':
        f = 'YYYY-MM-DD HH:mm:ss';
        break;
      case 'm':
        f = 'YYYY-MM-DD HH:mm:00';
        break;
      case 'H':
        f = 'YYYY-MM-DD HH:00:00';
        break;
      default:
        f = 'YYYY-MM-DD HH:mm:ss';
        break;
    }

    return +moment(moment().format(f));
  },
};

export default dataOpration;
